"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const get = (params) => {
    const response = params.httpInstance.get(params.url, {
        params: params.queryParams,
    });
    return response;
};
const post = (params) => {
    const response = params.httpInstance.post(params.url, params.body, {
        params: params.queryParams,
    });
    return response;
};
const put = (params) => {
    const response = params.httpInstance.put(params.url, params.body, {
        params: params.queryParams,
    });
    return response;
};
const deleteMJ = (params) => {
    const response = params.httpInstance.delete(params.url, {
        params: params.queryParams,
    });
    return response;
};
exports.default = { get, post, put, delete: deleteMJ };
//# sourceMappingURL=index.js.map